import React, { useState } from 'react';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { Button, type SxProps } from '@mui/material';
import { CookieSettingsDialog } from './CookieSettingsDialog';

interface IManageCookiesBtn {
  customStyles?: SxProps;
}
export const ManageCookiesBtn = ({ customStyles }: IManageCookiesBtn) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleOpenSettings: () => void = () => {
    setIsSettingsOpen(true);
  };

  const handleCloseSettings: () => void = () => {
    setIsSettingsOpen(false);
  };

  return (
    <>
      <Button
        variant="text"
        color="inherit"
        size="small"
        sx={{ fontWeight: 500, ...customStyles }}
        startIcon={<TuneRoundedIcon />}
        onClick={handleOpenSettings}>
        Configurar cookies
      </Button>
      <CookieSettingsDialog open={isSettingsOpen} onClose={handleCloseSettings} />
    </>
  );
};
